module.exports = __webpack_public_path__ + "img/csss_bordeaux.ba1def78.png";